var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileRedirectArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9997 2.50035C13.9997 2.36774 13.947 2.24056 13.8532 2.14679C13.7594 2.05302 13.6323 2.00035 13.4997 2.00035H7.49965C7.36705 2.00035 7.23987 2.05302 7.1461 2.14679C7.05233 2.24056 6.99965 2.36774 6.99965 2.50035C6.99965 2.63295 7.05233 2.76013 7.1461 2.8539C7.23987 2.94767 7.36705 3.00035 7.49965 3.00035H12.2927L2.14565 13.1463C2.09917 13.1928 2.06229 13.248 2.03713 13.3088C2.01197 13.3695 1.99902 13.4346 1.99902 13.5003C1.99902 13.5661 2.01197 13.6312 2.03713 13.6919C2.06229 13.7527 2.09917 13.8079 2.14565 13.8543C2.19214 13.9008 2.24733 13.9377 2.30807 13.9629C2.36881 13.988 2.43391 14.001 2.49965 14.001C2.5654 14.001 2.6305 13.988 2.69124 13.9629C2.75198 13.9377 2.80717 13.9008 2.85366 13.8543L12.9997 3.70735V8.50035C12.9997 8.63295 13.0523 8.76013 13.1461 8.8539C13.2399 8.94767 13.367 9.00035 13.4997 9.00035C13.6323 9.00035 13.7594 8.94767 13.8532 8.8539C13.947 8.76013 13.9997 8.63295 13.9997 8.50035V2.50035Z",
    fill: "#FF9D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileRedirectArrow);
export default __webpack_public_path__ + "static/media/ProfileRedirectArrow.57c0bbc88239bee8e8c8c357d8c6e56c.svg";
export { ForwardRef as ReactComponent };